import {Directive, ElementRef, EventEmitter, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {groupBy, includes, isEmpty, isNil, isUndefined} from 'lodash';
import {AutocompleteService} from '../../../../../../common/components/autocomplete';
import {ModelListener} from '../../../../../../common/components/model-listener';
import {CountryService} from './api/country.service';
import {Country} from './api/country';

const $ = require('jquery');
require('typeahead.js');

const PROVIDER: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CountrySelectDirective),
    multi: true
};

const navigationKeyCodes = [37, 38, 39, 40, 35, 36];

/**
 *  TODO refactor to component
 * */
@Directive({
    selector: '[ftl-country-select]',
    providers: [PROVIDER, AutocompleteService]
})
export class CountrySelectDirective extends ModelListener implements ControlValueAccessor, OnInit {

    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouchedCallback: EventEmitter<any> = new EventEmitter<any>();

    @Input('ac-key') keyParam: string = 'id';
    @Input('ac-value') valueParam: string = 'name';
    @Input('items-limit') itemsLimit: number = 5;
    @Input('min-query-length') minQueryLength: number = 1;
    @Input('menu-class') menuClass: string = 'tt-menu';

    private _keysMap: Object;
    private _valuesMap: Object;

    private countries: Country[];

    private countryChangeDetector: CountryChangeDetector = new CountryChangeDetector;

    constructor(private _el: ElementRef,
                private _countryService: CountryService,
                private _autocompleteService: AutocompleteService) {
        super();
    }

    valueFormatter(newValue) {
        if (!isEmpty(newValue)) {
            let item: any = this._keysMap[newValue];
            if (item && item[0] && item[0] !== null) {
                return item[0][this.valueParam];
            }
        }

        return newValue;
    }

    writeValue(obj) {
        super.writeValue(obj);
        this.countryChangeDetector.setValue(obj);
    }

    ngOnInit() {
        this.countryChangeDetector.onChange((obj) => {
            let key = this.keyFormatter(obj);
            if (!isNil(key)) {
                let valuesMap = groupBy(this.countries, this.keyParam);
                let item: any = valuesMap[key];
                if (!isUndefined(item)) {
                    $(this._el.nativeElement).typeahead('val', item[0][this.valueParam]);
                    return;
                }
            }

            $(this._el.nativeElement).typeahead('val', '');
        });

        this._countryService.getCountries()
            .subscribe(countries => {
                this.countries = countries;
                this.buildAutocompleteComponent();
                this.countryChangeDetector.setCountries(countries);
            });
    }

    /**
     * todo andrey resolve typescript lazy loading problem
     * noinspection TypeScriptValidateTypes,TypeScriptUnresolvedFunction
     * */
    private buildAutocompleteComponent() {
        let design = this.getAutocompleteDesignSettings();
        let dataSource = this.getAutocompleteDataSourceSettings();
        $(this._el.nativeElement).typeahead(design, dataSource)
            .on('typeahead:select', this.onTypeaheadSelect.bind(this))
            .on('typeahead:change', this.onTypeaheadChange.bind(this))
            .on('keyup', this.onTypeaheadKeyup.bind(this))
            .on('blur', this.onTypeaheadBlur.bind(this))
            .closest('.twitter-typeahead').css('display', 'block');
    }

    private getAutocompleteDesignSettings() {
        return {
            classNames: {
                menu: this.menuClass
            },
            hint: false,
            highlight: true,
            minLength: this.minQueryLength,
        }
    }

    private getAutocompleteDataSourceSettings() {
        return {
            source: this._autocompleteService.buildSuggestionEngine(
                () => this.countries,
                item => item[this.valueParam],
                source => {
                    this._keysMap = groupBy(source, this.keyParam);
                    this._valuesMap = groupBy(source, this.valueParam);
                }),
            limit: this.itemsLimit
        }
    }

    private onTypeaheadSelect(event) {
        let value = this._valuesMap[event.target.value];
        if (!!value && !!value[0]) {
            this.writeValue(value[0][this.keyParam])
        }
    }

    private onTypeaheadChange(event) {
        if (!isNil(this._valuesMap) && isNil(this._valuesMap[event.target.value])) {
            this.writeValue('');
        }
    }

    private onTypeaheadKeyup(event) {
        if (!includes(navigationKeyCodes, event.keyCode)) {
            if (!isNil(this._valuesMap) && !isNil(this._valuesMap[event.target.value])) {
                let item = this._valuesMap[event.target.value][0];
                this.writeValue(item[this.keyParam]);
            }
        }
    }

    private onTypeaheadBlur() {
        this.onTouchedCallback.emit();
    }
}

class CountryChangeDetector {

    private value: any;
    private countries: Country[];
    private callback: Function;

    public setValue(value: any) {
        this.value = value;
        this.tryEmitCallback();
    }

    public setCountries(countries: Country[]) {
        this.countries = countries;
        this.tryEmitCallback()
    }

    public onChange(cb: Function) {
        this.callback = cb;
    }

    private tryEmitCallback() {
        if (!!this.countries) {
            this.callback(this.value, this.countries);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/components/dictionary/country/country.select.directive.ts